import { SuggestVideoForm } from "@/components/SuggestVideo";

/**
 * Bloc d'appel à l'action "Une vidéo manque ?" à placer directement sous
 * une grille de vidéos. Il remplace l'ancien emplacement dans le footer
 * pour être plus visible contextuellement.
 */
export function SuggestVideoBlock({ context }: { context?: string }) {
  return (
    <section className="mt-14 rounded-2xl border border-border bg-card/40 p-5 sm:p-6">
      <div className="flex flex-col gap-5 md:flex-row md:items-start md:justify-between">
        <div className="max-w-xl">
          <p className="text-[0.6rem] uppercase tracking-[0.3em] text-muted-foreground">
            Enrichir le catalogue
          </p>
          <h2 className="mt-2 font-[family-name:var(--font-display)] text-xl uppercase tracking-wide">
            Une vidéo manque ? Envoyez-nous le lien
          </h2>
          <p className="mt-2 text-sm text-muted-foreground">
            Reportage, documentaire, captation ou archive sur la Corse : collez
            l'adresse de la vidéo, nous la vérifions et l'ajoutons au programme.
            {context ? ` Vous cherchiez : ${context}.` : ""}
          </p>
        </div>
        <div className="w-full min-w-0 md:max-w-md md:flex-1">
          <SuggestVideoForm compact />
        </div>
      </div>
    </section>
  );
}
